import { formatDocumentToApiDocument } from './document-to-api-document';
import { formatOptionalField } from './format-optional-field';

import {
  ApplicationData,
  onlineStoreDataGuard,
  PartnerApplicationContext,
  type PointOfSales,
  StoreData,
} from '../../model';

const POINT_OF_SALES_PHOTO_TYPE = 'POINT_OF_SALES_PHOTO' as const;

const mallUtilityOptions = ['OTHER', 'NONE'];

function formatMallId(mallId: string) {
  if (mallUtilityOptions.includes(mallId)) {
    return null;
  }

  return mallId;
}

function mapStoreDataToPointOfSales(store: StoreData): PointOfSales {
  if (onlineStoreDataGuard(store)) {
    return {
      type: store.details.type,
      uiId: store.details.uiId,
      name: store.details.name,
      email: store.details.email,
      contactNumber: store.details.contactNumber,
      avgMonthlySales: store.details.avgMonthlySales,
      websiteURL: store.details.websiteURL,
    };
  }

  return {
    type: store.details.type,
    uiId: store.details.uiId,
    name: store.details.name,
    email: store.details.email,
    contactNumber: store.details.contactNumber,
    tinCode: store.details.tinCode,
    avgMonthlySales: store.details.avgMonthlySales,
    websiteURL: formatOptionalField(store.details.websiteURL),
    mallId: formatMallId(store.address.mallId),
    mallNameOther: formatOptionalField(store.address.mallNameOther),
    address: {
      country: store.address.country,
      region: store.address.region,
      province: store.address.province,
      cityOrMunicipality: store.address.cityOrMunicipality,
      postalCode: store.address.postalCode,
      barangay: store.address.barangay,
      streetAndHouse: store.address.streetAndHouse,
      unitAndFloor: formatOptionalField(store.address.unitAndFloor),
    },
    areaSqm: formatOptionalField(store.details.areaSqm),
    numberOfFloors: store.details.numberOfFloors,
    hasCCTV: store.details.hasCCTV,
    dayOfRecording: formatOptionalField(store.details.dayOfRecording),
    coordinates: store.coordinates
      ? { lat: store.coordinates.lat, lon: store.coordinates.lng }
      : null,
    photos: store.photos.STORE_AND_MERCHANDISE_DISPLAY.map((doc) =>
      formatDocumentToApiDocument(doc, POINT_OF_SALES_PHOTO_TYPE)
    ),
  };
}

export function formatPointsOfSales(
  data: ApplicationData,
  values: Partial<PartnerApplicationContext>['pointsOfSales']
): ApplicationData {
  if (!values?.length) return { ...data, pointsOfSales: [] };

  return {
    ...data,
    pointsOfSales: values.map(mapStoreDataToPointOfSales),
  };
}
